module.exports = __webpack_public_path__ + "media/bootstrap-icons/wifi-off-16334613.svg";